import React, { CSSProperties } from 'react';

export enum SpriteSvgType {
  GcLogo = 'gc-logo',
  GcTitle = 'gc-title',
  ArrowDown = 'arrow-down',
  AccountOutline = 'account-outline',
  ChevronRightCircleOutline = 'chevron-right-circle-outline',
  CogOutline = 'cog-outline',
  HomeOutline = 'home-outline',
  ServiceDefault = 'service-default',
  ChevronDown = 'chevron-down',
  ServiceMatchmaking = 'service-matchmaking',
  ServiceBattle = 'service-battle',
  serviceDatabase = 'service-database',
  HomeCircle = 'home-circle',
  Hosting = 'hosting-outline',
  Player = 'player-outline',
  Stats = 'stats-outline',
  AccountCenter = 'account-center',
  Back = 'back-icon',
  Organization = 'organization',
  Message = 'message',
  Eclipsis = 'eclipsis',
  CustomData = 'custom-data',
  Gadgets = 'gadgets',
  AutoTask = 'auto-task',
  LeaderBoards = 'leader-boards',
  Mail = 'mail',
  Commands = 'commands',
  GameItems = 'game-items',
  Store = 'store',
  NewTitle = 'new-title',
  User = 'user',
  ServiceApplication = 'service-application',
  Command = 'command',
  KeyboardK = 'keyboard-k',
  LanguageZH = 'language-zh',
  LanguageEN = 'language-en',
  BellDark = 'bell-dark',
  SearchDark = 'search-dark',
  KeyboardCtrl = 'keyboard-ctrl',
  KeyboardUp = 'keyboard-up',
  KeyboardDown = 'keyboard-down',
  KeyboardEnter = 'keyboard-enter',
  Delete = 'del-icon',
  Refresh = 'refresh',
  PayQuantity = 'pay-quantity',
  Edit = 'edit',
  AccountApprove = 'account-approve',
  AccountApply = 'account-apply',
  BusinessNotice = 'business-notice',
  MessagePush = 'message-push',
  MessageUpgrade = 'message-upgrade',
  Calculator = 'calculator',
  DownloadNews = 'download-news',
  ExpandArrow = 'expand-arrow',
}
interface IProps {
  readonly type: SpriteSvgType;
  readonly className?: string;
  readonly style?: CSSProperties;
  readonly width?: number;
  readonly height?: number;
  readonly marginLeft?: number;
  readonly fill?: string;
  readonly onClick?: (ev: React.MouseEvent<SVGElement>) => void;
}
export const SpriteSvg = (props: IProps) => {
  return (
    <svg
      aria-hidden={true}
      className={props.className}
      width={props.width}
      height={props.height}
      onClick={props.onClick}
      fill={props.fill}
      style={{
        marginLeft: props.marginLeft ? props.marginLeft : '0',
        ...props.style,
      }}
    >
      <use xlinkHref={`#${props.type}`}></use>
    </svg>
  );
};
